import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DisabledChip } from '@cbridge-tools/chip';

export const BooleanCellFalseChip: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <DisabledChip label={t('text:common.status.disabled')} />
  );
};
